import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-future-bsc-it-career-opportunities',
  templateUrl: './future-bsc-it-career-opportunities.component.html',
  styleUrls: ['./future-bsc-it-career-opportunities.component.scss']
})
export class FutureBscItCareerOpportunitiesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
